import {getStationCode} from "../../network/NetworkUtil";
import {
    getAPIGatewayDataFromParent,
    getCycleDataFromParent
} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/Util";
import {CAPABILITY, METRIC} from "../../util/Constants";
import {chainWalk} from "../../util/Util";
import {ASL_INDUCT_AREA_ACTIONS} from "../../technician/reducer/ASLInductAreaReducer";

const metricProcessName = "SCC_INDUCT";

const INDUCT_ENDPOINT = {
    GET_MHE_LOCATION_METRIC: "ivs/getMHELocationMetric"
}

/**
 * API call for fetching Induct Overview
 * @param filter
 * @param capability
 * @param dispatcher
 */
export function fetchInductOverview(filter, capability, dispatcher, isCPTFilterEnabled) {
    let filterMap;

    if(isCPTFilterEnabled){
        filterMap = {
            [filter.filterIdentifier]: filter.selectedCPT.map(CPTDetail => CPTDetail.id)
        }
    }
    else{
        filterMap = {
            'Cycle': filter.selectedCycles,
        }
    }

    const request = {
        nodeId: getStationCode(),
        groupBy: 'Node',
        filters: filterMap,
        metricList: ["PENDING_DEPART_FROM_UPSTREAM", "PENDING_DEPART_FROM_UPSTREAM_UNPLANNED", "IN_TRANSIT_FROM_UPSTREAM",
            "IN_TRANSIT_FROM_UPSTREAM_UNPLANNED", "PENDING_INDUCT", "PENDING_INDUCT_UNPLANNED", "PENDING_RE_INDUCT",
            "PENDING_RE_INDUCT_UNPLANNED", "INDUCTED_AT_STATION", "PLANNED_CURRENT_CYCLE_INDUCTED",
            "UNPLANNED_CURRENT_CYCLE_INDUCTED"]
    }

    if (CAPABILITY.AR_NEXT_GEN === capability) {
        request.metricList.push("PROBLEM_SOLVE")
    } else {
        request.metricList.push("SIDELINE")
    }

    getPackageMetrics(filter, dispatcher, request);
    fetchStowNumber(filter, dispatcher, isCPTFilterEnabled);
    fetchContainerPlannedNumber(filter, dispatcher, isCPTFilterEnabled);
}

function getReceiveDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getPackageMetric",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getPackageMetrics(filter, dispatcher, request) {
    const args = getReceiveDataAPIGatewayRequest(request);
    const startTime = Date.now();
    const isSingleFilterSelected = ((filter.selectedCycles.length === 1 && !filter.selectedCycles.includes("NONE")) ||
        (filter.selectedCPT.length === 1 && !filter.selectedCPT.includes("NONE")));

    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageMetric", true);
            const output = result.data.groupedPackageMetrics
            const stationCode = getStationCode()
            dispatcher({type: "RECEIVE_DATA", data: {
                    pending_depart_from_upstream: (output.PENDING_DEPART_FROM_UPSTREAM)[stationCode],
                    pending_depart_from_upstream_unplanned: (output.PENDING_DEPART_FROM_UPSTREAM_UNPLANNED)[stationCode],
                    in_transit_from_upstream: (output.IN_TRANSIT_FROM_UPSTREAM)[stationCode],
                    in_transit_from_upstream_unplanned: (output.IN_TRANSIT_FROM_UPSTREAM_UNPLANNED)[stationCode],
                    pending_induct: (output.PENDING_INDUCT)[stationCode],
                    pending_induct_unplanned: (output.PENDING_INDUCT_UNPLANNED)[stationCode],
                    pending_re_induct: (output.PENDING_RE_INDUCT)[stationCode],
                    pending_re_induct_unplanned: (output.PENDING_RE_INDUCT_UNPLANNED)[stationCode],
                    inducted: (output.INDUCTED_AT_STATION)[stationCode],
                    planned_inducted: isSingleFilterSelected? (output.PLANNED_CURRENT_CYCLE_INDUCTED)[stationCode]: "-",
                    unplanned_inducted: isSingleFilterSelected? (output.UNPLANNED_CURRENT_CYCLE_INDUCTED)[stationCode]: "-",
                    sidelined: chainWalk(() => (output.SIDELINE)[stationCode]),
                    problem_solve: chainWalk(() => (output.PROBLEM_SOLVE)[stationCode]),
                    total_inducted_actual: isSingleFilterSelected? (output.PLANNED_CURRENT_CYCLE_INDUCTED)[stationCode] + (output.UNPLANNED_CURRENT_CYCLE_INDUCTED)[stationCode]: "-"
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageMetric", false);
        }
    });
}


/**
 * API call for fetching stow number
 */

function fetchStowNumber(filter, dispatcher, isCPTFilterEnabled)  {
    let requestFilter;
    if (filter && filter.selectedCPT.length > 0 && isCPTFilterEnabled) {
        requestFilter = {
            NODE: [getStationCode()],
            [filter.filterIdentifier]: filter.selectedCPT.map(CPTDetail => CPTDetail.id)
        }
    } else if(filter && filter.selectedCycles.length > 0 && !isCPTFilterEnabled) {
        requestFilter = {
            NODE: [getStationCode()],
            CYCLE: filter.selectedCycles
        }
    } else{
        requestFilter = {
            NODE: [getStationCode()]
        }
    }
    const request = {
        filters: requestFilter,
        groupBy: 'NONE',
        metrics: ["CURRENT_STOWED_COUNT", "CURRENT_STOW_BUFFERED_COUNT"]
    }
    getStowMetrics(dispatcher, request);
}

function getStowAPIGatewayRequest(request) {
    return {
        resourcePath: "svs/packages/metrics",
        httpMethod: "post",
        processName: "stow",
        requestBody: request
    }
}

async function getStowMetrics(dispatcher, request) {
    const args = getStowAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getStowData", true);
            const output = result.data.groupedPackageMetrics
            if("Total" in output) {
                dispatcher({
                    type: "RECEIVE_STOW_DATA", data: {
                        stowed: (output["Total"]).currentStowedCount,
                        stow_buffered: (output["Total"]).currentStowBufferedCount
                    }
                });
            }
        } else {
            logOperationalMetric(startTime, metricProcessName, "getStowData", false);
        }
    });
}


/**
 * API call for fetching location metrics
 * @param dispatcher
 */
export function fetchLocationMetrics(dispatcher) {
    const request = {
        nodeId: getStationCode()
    }
    getLocationMetrics(dispatcher, request)
}

/**
 * API call for fetching MHE location metrics
 * @param filter
 * @param dispatcher
 */
export function fetchMHELocationMetrics(filter, dispatcher) {
    const request = {
        nodeId: getStationCode()
    }
    getMHELocationMetrics(dispatcher, request)
}

function fetchLocationMetricsAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getLocationMetric",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

function fetchInductAPIGatewayRequest(resourcePath, requestBody) {
    return {
        resourcePath,
        httpMethod: "post",
        processName: "induct",
        requestBody
    }
}

async function getLocationMetrics(dispatcher, request) {
    const args = fetchLocationMetricsAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getLocationData", true);
            let output = result.data.locationInsightList
            let locationMetrics = output.filter(location => location.volumeInducted > 0)
            const total = getAggregateMetrics(locationMetrics);
            if (total != null) {
                locationMetrics.push(total)
            }
            dispatcher({type: "INDUCT_AREA_INSIGHT", data: {
                    inductAreaData: locationMetrics
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getLocationData", false);
        }
    });
}

async function getMHELocationMetrics(dispatcher, request) {
    const args = fetchInductAPIGatewayRequest(INDUCT_ENDPOINT.GET_MHE_LOCATION_METRIC, request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, METRIC.GET_MHE_LOCATION_DATA, true);
            let locationMetrics = result.data.mheLocationInsightList
            dispatcher({type: ASL_INDUCT_AREA_ACTIONS.MHE_INDUCT_AREA_INSIGHT, data: {
                    mheInductAreaData: locationMetrics
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, METRIC.GET_MHE_LOCATION_DATA, false);
        }
    });
}

function getAggregateMetrics(locationMetrics) {
    if (locationMetrics.length === 0) {
        return null;
    }
    const aggregateMetric = {
        locationName: 'Total',
        associateType:'',
        operatorCount: 0,
        inductRate: 0,
        volumeInducted: 0
    }
    locationMetrics.forEach(metrics => {
        aggregateMetric.operatorCount = aggregateMetric.operatorCount + metrics.operatorCount
        aggregateMetric.inductRate = aggregateMetric.inductRate + metrics.inductRate
        aggregateMetric.volumeInducted = aggregateMetric.volumeInducted + metrics.volumeInducted
    })
    return aggregateMetric;
}

/**
 * API to fetch LineHauls List and associated container details
 * @param filter
 * @param dispatcher
 */
export function fetchLineHaulsContainerDetails(filter, dispatcher) {
    getArrivedLineHaulList(filter, dispatcher);
}

function getLineHaulListAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getNodeLineHaulList",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getArrivedLineHaulList(filter, dispatcher) {
    const request = {
        nodeId: getStationCode()
    }
    const args = getLineHaulListAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getArrivedLineHaul", true);
            const lineHaulList = [];
            const output = result.data.lineHauls;
            output.forEach(lineHaul => {
                if (lineHaul.lineHaulStatus === "ARRIVED" && lineHaul.volume > 0) {
                    lineHaulList.push(lineHaul.lineHaulId);
                }
            });
            fetchLineHaulsContainerList(filter, dispatcher, lineHaulList)
            dispatcher({type: "LINE_HAUL_DATE_RECEIVED", data: {
                    lineHaulList: lineHaulList
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getArrivedLineHaul", false);
        }
    });
}

export function fetchLineHaulsContainerList(filter, dispatcher, lineHaulList) {
    if (lineHaulList && lineHaulList.length > 0) {
        let filterMap = {
            "Cycle": filter.Cycle,
            [filter.filterIdentifier]: filter.Filters.CPT.filter(CPTDetail => filter.CPT.includes(CPTDetail.label))
                .map(CPTDetail => CPTDetail.id),
            "EAD": filter.EAD,
            "OtherAttributes": filter.OtherAttributes,
            "Cluster": filter.Cluster,
            "PackageSize": filter.PackageSize
        };
        const request = {
            nodeId: getStationCode(),
            lineHaulId: lineHaulList,
            filters: filterMap
        };
        getContainerDetail(dispatcher, request);
    }
}

function getContainerDetailAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getLineHaulContainerDetail",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getContainerDetail(dispatcher, request) {
    const args = getContainerDetailAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getLineHaulContainer", true);
            let output = result.data.lineHaulsContainerDetail;
            dispatcher({type: "LINE_HAULS_CONTAINER_DATA_RECEIVED", data: {
                    containerDetail: (output) ? output : {}
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getLineHaulContainer", false);
        }
    });
}

function fetchContainerPlannedNumber(filter, dispatcher, isCPTFilterEnabled) {
    const isSingleFilterSelected = ((filter.selectedCycles.length === 1 && !filter.selectedCycles.includes("NONE")) ||
        (filter.selectedCPT.length === 1 && !filter.selectedCPT.includes("NONE")));

    if (isSingleFilterSelected) {
        let requestFilter;
        if(isCPTFilterEnabled){
            requestFilter= {
                NODE: [getStationCode()],
                [filter.filterIdentifier]: filter.selectedCPT.map(CPTDetail => CPTDetail.id)
            }
        }
        else{
            requestFilter= {
                NODE: [getStationCode()],
                CYCLE_ID: filter.allCycles.filter(cycleDetail => filter.selectedCycles.includes(cycleDetail.cycleId))
                    .map(cycleDetail => cycleDetail.casCycleId)
            }
        }
        const request = {
            filters: requestFilter,
            groupBy: 'NODE',
            metrics: ["PLANNED_COUNT"]
        }

        getContainerPlannedMetrics(dispatcher, request);
    } else {
        dispatcher({
            type: "RECEIVE_PLANNED_DATA", data: {
                planned_cycle_volume: '-'
            }
        });
    }
}


async function getContainerPlannedMetrics(dispatcher, request) {
    const args = getStowAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getContainerPlannedMetric", true);
            const output = result.data.groupedPackageMetrics
            const stationCode = getStationCode()
            dispatcher({type: "RECEIVE_PLANNED_DATA", data: {
                    planned_cycle_volume: (output[stationCode]) ? (output[stationCode]).plannedCount : '-'
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getContainerPlannedMetric", false);
        }
    });
}

/**
 * API Call to fetch cycles
 * @param dispatcher
 */
export function fetchCycles(dispatcher) {
    getCycleDataFromParent().then(cycleData => {
        let data = JSON.parse(cycleData.cycleList).filter(cycle => cycle.cycleId !== 'AllCycles')
        const unplanned = {
            casCycleId: null,
            cycleId: "NONE",
            cycleName: "NONE"
        }
        data = [...data, unplanned]
        dispatcher({type: "RECEIVE_CYCLE", data: {cycles: data}})
    })
}

/**
 * API Call to fetch CPT
 * @param dispatcher
 */

function getCPTDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getStationCPTs",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

export function fetchCPTList(dispatcher) {

    const request = {
        nodeId: getStationCode(),
    }
    const args = getCPTDataAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", true);
            const output = result.data;
            let data= JSON.parse(output.CPTList).filter(CPT => CPT.label !== 'ALL')
            const unplanned = {
                id: "NONE",
                label: "NONE"
            }
            data = [...data, unplanned]
            dispatcher({type: "RECEIVE_CPT", data: {CPT: data}})
            dispatcher({type: "ASSIGN_LABEL", data: {CPTLabel: output.CPTTypeLabelKey}})
            dispatcher({type: "ASSIGN_FILTER_IDENTIFIER", data: {filterIdentifier: output.filterIdentifier}})
        } else {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", false);
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/induct/network/InductNetworkAPI.js